import Title from 'atoms/Title';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import ImageGallery from 'molecules/ImageGallery';
import React, { useEffect } from 'react';
import { ITag } from 'stores/interfaces';
import { getOfferingTag } from 'stores/offeringUtils';
import { useStore } from 'stores/store';
import { IGalleryItem, LatLon } from 'utils/globalTypes';

import s from './InfoCard.module.scss';

interface IInfoCard {
  item: {
    offering_id?: string;
    showBullets?: boolean;
    offering_name?: string;
    asset_type?: string;
    description?: string;
    tag?: ITag;
    sponsor_logo?: string;
    geo_location?: LatLon;
    gallery_media?: IGalleryItem[];
  };
}

const InfoCard = ({ item }: IInfoCard) => {
  const { AssetStore } = useStore();

  const { offering_id, asset_type, offering_name, description, gallery_media } = item;
  const isActive = AssetStore.activeItemId == offering_id;
  const isSelected = AssetStore.selectedItemId == offering_id;

  useEffect(() => {
    // close POI on unmount
    return () => {
      AssetStore.clearSelected(item);
    };
  }, [AssetStore, item]);

  const setToggle = (activeState: boolean) => {
    AssetStore.setActiveItem(item, activeState);
  };

  return (
    <div
      className={cn(s.InfoCard, { isActive: (item && isActive) || isSelected })}
      onMouseEnter={() => setToggle(true)}
      onMouseLeave={() => setToggle(false)}
    >
      <div className={s.InfoCard__galleryWrapper}>
        <ImageGallery images={gallery_media} tag={getOfferingTag(item)} showBullets isPreviewMode />
      </div>
      <div className={s.InfoCard__description}>
        <div className={s.InfoCard__titleWrapper}>
          <Title classnames={s.InfoCard__title} size={5}>
            {offering_name || ''}
          </Title>
          <div className={s.InfoCard__subTitle}>
            {asset_type}
            {description && ` | ${description}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(InfoCard);
